import { ExamLocationRequestApprovalType, ExamLocationVerdict } from '@exam-center/graphql';
import { Box, Divider, EventAvailableOutlinedIcon, Flex, Text } from '@shared/components';

import { VerdictResultLabel } from '../verdict-result-label';
interface ExamCenterLocationRequestVerdictResultCardProps {
  fullName: string;
  comment: string;
  submittedAt: string;
  approverNumber: number;
  verdict: ExamLocationVerdict;
  approvalType: ExamLocationRequestApprovalType | null;
}

export default function ExamCenterLocationRequestVerdictResultCard(
  props: Readonly<ExamCenterLocationRequestVerdictResultCardProps>,
) {
  const { fullName, comment, submittedAt, approverNumber, verdict, approvalType } = props;

  return (
    <Box
      sx={(theme) => ({
        p: theme.spacing(4),
        border: '1px solid',
        borderColor: theme.palette.divider,
        borderRadius: theme.shape.rounded(2),
      })}
    >
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          gap: theme.spacing(2),
          borderLeft: '4px solid',
          pl: theme.spacing(4),
          borderColor:
            verdict === ExamLocationVerdict.Approved
              ? theme.palette.success.main
              : theme.palette.error.main,
        })}
      >
        <Flex
          sx={{
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          }}
        >
          <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(2) }}>
            <Text>
              ผู้อนุมัติลำดับที่ {approverNumber}: <Text variant='body1Semibold'>{fullName}</Text>
            </Text>
            <Text variant='body2' color='text.secondary'>
              ความคิดเห็นเพิ่มเติม: {comment}
            </Text>
            <Flex sx={{ gap: (theme) => theme.spacing(1), alignItems: 'center' }}>
              <EventAvailableOutlinedIcon
                sx={{ color: (theme) => theme.palette.text.secondary, fontSize: 16 }}
              />
              <Text variant='body2' color='text.secondary'>
                วันที่{verdict === ExamLocationVerdict.Rejected ? 'ไม่' : null}อนุมัติ:{' '}
                {submittedAt}
              </Text>
            </Flex>
          </Flex>
          <VerdictResultLabel variant={verdict} />
        </Flex>
        {approvalType ? (
          <>
            <Divider />
            <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(2) }}>
              <Text variant='body2'>
                สิทธิ์การใช้งานสถานที่:{' '}
                <Text variant='body2Semibold'>
                  {approvalType === ExamLocationRequestApprovalType.GrantAccess
                    ? 'เปิดสิทธิ์'
                    : 'อนุมัติใหม่'}
                </Text>
              </Text>
            </Flex>
          </>
        ) : null}
      </Flex>
    </Box>
  );
}
